import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-physical-audio';
export var ID = 'icon-physical-audio';
/* eslint-disable max-len */

export var SVGPhysicalAudio = function SVGPhysicalAudio() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 Z M8,11.5 C9.93299662,11.5 11.5,9.93299662 11.5,8 C11.5,6.06700338 9.93299662,4.5 8,4.5 C6.06700338,4.5 4.5,6.06700338 4.5,8 C4.5,9.93299662 6.06700338,11.5 8,11.5 Z M8,9.5 C7.17157288,9.5 6.5,8.82842712 6.5,8 C6.5,7.17157288 7.17157288,6.5 8,6.5 C8.82842712,6.5 9.5,7.17157288 9.5,8 C9.5,8.82842712 8.82842712,9.5 8,9.5 Z"
  }));
};
/* eslint-disable max-len */

var PhysicalAudio = function PhysicalAudio(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGPhysicalAudio
  });
};

PhysicalAudio.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default PhysicalAudio;